import React from 'react';
import { useHolidayPrefs } from '../hooks/useHolidayPrefs';
import { visibleHolidayPillCount } from '../calendar/holidayPreferences';

// Mounted only inside signed-in account surfaces.
export function HolidayCount() {
  const { ready, error, hiddenHolidays } = useHolidayPrefs();
  return <span>{ready ? `${visibleHolidayPillCount(hiddenHolidays)} on your calendar` : error ? 'Manage holidays' : 'Loading…'}</span>;
}
